import React from 'react';
import s from './Table.scss';
export var Table = function (_a) {
    var columns = _a.columns, items = _a.items, columnGap = _a.columnGap;
    var rowStyle = {
        gridTemplateColumns: columns.map(function (c) { return c.width; }).join(' '),
        gap: columnGap,
    };
    return (React.createElement("table", { style: { width: '100%' }, className: s.table },
        React.createElement("thead", { className: s.header },
            React.createElement("tr", { className: s.row, style: rowStyle }, columns.map(function (col, idx) {
                var _a;
                return (React.createElement("th", { key: idx, style: { justifySelf: (_a = col.align) !== null && _a !== void 0 ? _a : 'start' } }, col.header));
            }))),
        React.createElement("tbody", null, items.map(function (item, index) { return (React.createElement("tr", { key: index, className: "".concat(s.row, " ").concat(s.data), style: rowStyle }, columns.map(function (col, idx) {
            var _a;
            return (React.createElement("td", { key: idx, className: s.rowCell, style: { justifySelf: (_a = col.align) !== null && _a !== void 0 ? _a : 'start' } }, col.value(item, index)));
        }))); }))));
};
//# sourceMappingURL=Table.js.map